import "./title-card.css";

function TitleCard() {
    return (
        <section className="title-card">
            <h1 className="title">Frontend Mentor</h1>
            <p className="text">Feedback Board</p>
        </section>
    )
};

export default TitleCard;